// eslint-disable-next-line strict
module.exports = null;



//////////////////
// WEBPACK FOOTER
// ./~/sendbird/~/axios/lib/helpers/null.js
// module id = 1020
// module chunks = 42